export default "__VITE_ASSET__BHc8Wg65__"